// extracted by mini-css-extract-plugin
module.exports = {"reviewsImg":"Main-module--reviewsImg--SlWLa","bottomWrapper":"Main-module--bottomWrapper--KreUr","mainVideo":"Main-module--mainVideo--2GFQW","baner":"Main-module--baner--1YrdN"};